// Smoothing for the Skipper/sentiment generate progress bar. Numeric values ease
// toward the target (decelerating when overshooting); a non-numeric truthy tick
// nudges +1 (indeterminate work); a falsy value resets to 0. Capped at 100.
export const nextProgress = (prev, value) =>
  Number(value) === value
    ? Math.min(100, prev > value ? prev + 4 / (prev - value) : value + 0.5)
    : Math.min(100, value ? prev + 1 : 0)
